module.exports = __webpack_public_path__ + "img/gradient_button_callout.6a1ce59b.svg";